export default __webpack_public_path__ + "static/media/bannerIMG.e28fdc78.png";